import useTheme from '@mui/material/styles/useTheme';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Trans } from 'react-i18next';
import { onRamperStyles } from './onRamperStyles';

export interface IOnRamperProps {
  handleClick?: () => void;
  isCard?: boolean;
  href?: string;
}
export const OnRamper = ({
  isCard = false,
  handleClick,
  href
}: IOnRamperProps) => {
  const theme = useTheme();
  const classes = onRamperStyles(theme, isCard);
  const bnbSymbolPaymentToken = 'BNB';

  return (
    <Box sx={classes.container}>
      <Typography component='div' variant='subtitle2' sx={classes.text}>
        <Trans
          i18nKey={'vesting.onramper.text'}
          values={{ unit: bnbSymbolPaymentToken }}
          components={[
            <Link
              target='_blank'
              href={href}
              sx={classes.link}
              onClick={handleClick}
            />
          ]}
        />
      </Typography>
    </Box>
  );
};
